export const CITIES = ["Riyadh", "Jeddah", "Dubai", "Doha", "Kuwait City", "Muscat"];
export const INDUSTRIES = ["Clinic", "Restaurant", "Real Estate", "Gym", "Salon", "Other"];

export const CITY_CURRENCY = {
  Riyadh: "SAR", Jeddah: "SAR", Dubai: "AED",
  Doha: "QAR", "Kuwait City": "KWD", Muscat: "OMR",
};

export const CITY_DIALECT = {
  Riyadh: { en: "Najdi", ar: "نجدي" },
  Jeddah: { en: "Hijazi", ar: "حجازي" },
  Dubai: { en: "Gulf (Emirati)", ar: "خليجي (إماراتي)" },
  Doha: { en: "Gulf (Qatari)", ar: "خليجي (قطري)" },
  "Kuwait City": { en: "Kuwaiti", ar: "كويتي" },
  Muscat: { en: "Omani", ar: "عماني" },
};

export const CITY_INDUSTRY_VALUE = {
  Riyadh: { Clinic: 200, Restaurant: 150, "Real Estate": 500, Gym: 100, Salon: 120, Other: 150 },
  Jeddah: { Clinic: 180, Restaurant: 130, "Real Estate": 450, Gym: 90, Salon: 110, Other: 140 },
  Dubai: { Clinic: 400, Restaurant: 200, "Real Estate": 800, Gym: 150, Salon: 180, Other: 250 },
  Doha: { Clinic: 300, Restaurant: 180, "Real Estate": 600, Gym: 120, Salon: 150, Other: 200 },
  "Kuwait City": { Clinic: 25, Restaurant: 15, "Real Estate": 60, Gym: 10, Salon: 12, Other: 15 },
  Muscat: { Clinic: 20, Restaurant: 12, "Real Estate": 50, Gym: 8, Salon: 10, Other: 12 },
};

export const defaultValue = (city, industry) => CITY_INDUSTRY_VALUE[city]?.[industry] ?? 150;
